import { cn } from "@/lib/utils";

export function Prose({ children, className, ...props }: React.ComponentProps<"article">) {
  return (
    <article
      className={cn(
        "prose max-w-none dark:prose-invert prose-hr:mt-[2em] prose-hr:mb-[2em] prose-img:border prose-img:border-accent prose-img:rounded-lg prose-img:max-w-64 prose-a:break-all",
        className
      )}
      {...props}
    >
      {children}
    </article>
  );
}

export function ReasoningProse({ children, className, ...props }: React.ComponentProps<"article">) {
  return (
    <article
      className={cn(
        "prose prose-sm max-w-full dark:prose-invert prose-hr:mt-[1.5em] prose-hr:mb-[1.5em] prose-img:rounded-lg prose-img:size-20 prose-img:object-contain prose-h1:text-sm prose-h2:text-sm prose-h3:text-sm prose-h4:text-sm prose-h5:text-sm prose-h6:text-sm prose-p:text-sm prose-li:text-sm prose-a:text-sm prose-a:break-all",
        className
      )}
      {...props}
    >
      {children}
    </article>
  );
}
